import React, { useReducer } from 'react'
import { useForm, Controller } from 'react-hook-form'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import CircularProgress from '@material-ui/core/CircularProgress'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../../store/auth'
import { post } from '../../config/fetch'
import { TOKEN_SING_IN } from '../../constants/constants'

const useStyles = makeStyles(theme => ({
    root: {
        height: '100vh',
    },
    image: {
        backgroundImage:
            'url(https://lh3.googleusercontent.com/PRddTIn_rdXnpkzcMhvQ-5jdj_rJY6vjWdmVz_XMPnrx_6z_QEgcfjkH_sWeTn5pB1Q)',
        backgroundRepeat: 'no-repeat',
        backgroundColor: theme.palette.grey[50],
        backgroundSize: '40%',
        backgroundPosition: 'center',
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.dark,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    gridPaper: {
        backgroundColor: theme.palette.primary.background,
    },
}))

export default function SignIn(props) {
    const { handleSubmit, control } = useForm()
    const history = useHistory()
    const classes = useStyles()
    const auth = useAuth()
    const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
        error: null,
        loading: false,
        resolved: false,
    })

    const handleSignIn = async data => {
        setState({
            ...state,
            error: null,
            loading: true,
        })
        post('/signin?code=' +  TOKEN_SING_IN, data)
            .then(async res => {
                if (res.success) {
                    setState({
                        ...state,
                        loading: false,
                        resolved: true,
                    })
                    await auth.signin('user')
                    history.push('/')
                } else {
                    setState({
                        ...state,
                        loading: false,
                        resolved: false,
                        error: res.errors.msg,
                    })
                }
            })
            .catch(e => {
                console.log(e)
            })
    }

    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid
                item
                xs={12}
                sm={8}
                md={5}
                component={Paper}
                elevation={6}
                square
                className={classes.gridPaper}
            >
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Sign in
                    </Typography>
                    <form type="submit" className={classes.form} noValidate onSubmit={handleSignIn}>
                        <Controller
                            control={control}
                            name="email"
                            rules={{ required: true }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    variant="outlined"
                                    margin="normal"
                                    label="Email address"
                                    type="text"
                                    autoFocus
                                    autoComplete="email"
                                    fullWidth
                                    required
                                    inputRef={field.ref}
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                        <Controller
                            control={control}
                            name="password"
                            rules={{ required: true }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    variant="outlined"
                                    margin="normal"
                                    label="Password"
                                    type="password"
                                    autoFocus
                                    autoComplete="password"
                                    fullWidth
                                    required
                                    inputRef={field.ref}
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={handleSubmit(handleSignIn)}
                        >
                            {state.loading ? <CircularProgress color="inherit" /> : 'Sign In'}
                        </Button>
                    </form>
                    <p>{state.error}</p>
                </div>
            </Grid>
        </Grid>
    )
}
